var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("form", { on: { submit: _vm.showReport } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("p", [_vm._v("Начало периода")]),
                _vm._v(" "),
                _c("DateSelect", {
                  ref: "start_date",
                  attrs: { selectedDate: _vm.periodDates.start },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-3" },
              [
                _c("p", [_vm._v("Конец периода")]),
                _vm._v(" "),
                _c("DateSelect", {
                  ref: "end_date",
                  attrs: { selectedDate: _vm.periodDates.end },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row p-t-10" }, [
            Object.keys(_vm.divisions).length
              ? _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.showDivisions = !_vm.showDivisions
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.showDivisions ? "Скрыть" : "Показать") +
                          " дивизионы\n            "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _vm._v("\n            Проекты\n          "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                [
                  _c("label", { attrs: { for: "check_1" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showRUB,
                          expression: "showRUB",
                        },
                      ],
                      staticClass: "from-control",
                      attrs: { type: "checkbox", id: "check_1" },
                      domProps: {
                        checked: Array.isArray(_vm.showRUB)
                          ? _vm._i(_vm.showRUB, null) > -1
                          : _vm.showRUB,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showRUB,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.showRUB = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.showRUB = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.showRUB = $$c
                            }
                          },
                          _vm.updateTotalFigures,
                        ],
                      },
                    }),
                    _vm._v(
                      "\n                показать выторг в RUB\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        type: "submit",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v("Показать\n              ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "division_select_list" },
            _vm._l(_vm.getSortedDivisions(), function (division, i) {
              return _vm.showDivisions && division.id !== "0"
                ? _c("div", [
                    _c(
                      "button",
                      {
                        class: {
                          btn: true,
                          "btn-outline-primary": true,
                          active: division.selected,
                        },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            division.selected = !division.selected
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "user" }, [
                          _c("strong", [
                            _vm._v(_vm._s(division?.title ?? "не определен")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "user" }, [
                          _vm._v(
                            _vm._s(division?.user?.short_name ?? "не определен")
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "stores" },
                          [
                            _vm._l(division.cities, function (city, i) {
                              return _c("span", [
                                _vm._v(
                                  _vm._s(i !== 0 ? ", " : "") +
                                    "\n                    " +
                                    _vm._s(
                                      city.object_id === 0
                                        ? "Почта"
                                        : _vm.$AllCities[city.object_id].name
                                    )
                                ),
                              ])
                            }),
                            _vm._v("\n                ("),
                            _vm._l(division.stores, function (store, i) {
                              return _c("span", [
                                _vm._v(
                                  _vm._s(i !== 0 ? ", " : "") +
                                    _vm._s(
                                      _vm.$AllStores[store.object_id]
                                        .short_title
                                    )
                                ),
                              ])
                            }),
                            _vm._v(")\n              "),
                          ],
                          2
                        ),
                      ]
                    ),
                  ])
                : _vm._e()
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.loading && _vm.records && Object.keys(_vm.records).length
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "overflow-auto p-t-10" }, [
              _c("table", { staticClass: "table table-sm table-hover" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th"),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c("th", { key: divId }, [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$AllDivisions[divId]?.title ??
                                      "не определен " + divId
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.$AllDivisions[divId].cities.length > 1
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "info_block" },
                                      [
                                        _c(
                                          "v-popover",
                                          {
                                            attrs: {
                                              popoverClass: "",
                                              placement: "bottom",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-info info_fa",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "popover" },
                                              _vm._l(
                                                _vm.$AllDivisions[divId].cities,
                                                function (city) {
                                                  return _c(
                                                    "p",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          city.city.short_name
                                                        ) +
                                                          " -\n                          "
                                                      ),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            (
                                                              (_vm.citiesData[
                                                                city.city.id
                                                              ] &&
                                                                _vm.citiesData[
                                                                  city.city.id
                                                                ].total) ||
                                                              0
                                                            ).toLocaleString(
                                                              "ru-RU"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("th", [_vm._v("Итого")]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c(
                          "td",
                          { key: divId },
                          [
                            _vm.records[divId]
                              ? [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.records[
                                            divId
                                          ].total.toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "site_sum" },
                                      _vm._l(
                                        _vm.records[divId].sites,
                                        function (data, siteId) {
                                          return _c("p", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$AllProjects[siteId]
                                                    ?.title ??
                                                    "no title " + siteId
                                                ) +
                                                ":\n                      "
                                            ),
                                            data
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      Math.round(
                                                        data.total
                                                      ).toLocaleString("ru-RU")
                                                    ) +
                                                      "\n                          (" +
                                                      _vm._s(
                                                        Math.round(
                                                          (data.total * 100) /
                                                            _vm.records[divId]
                                                              .total
                                                        )
                                                      ) +
                                                      "%)"
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("0")]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              : [
                                  _vm._v(
                                    "\n                no data\n              "
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalData.income.toLocaleString("ru-RU"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "site_sum" },
                          [
                            _vm._l(
                              _vm.$AllProjects,
                              function (project, projectId) {
                                return [
                                  _vm.totalData.statBySite[projectId]
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              project?.title ??
                                                "no title " + projectId
                                            ) +
                                            ": " +
                                            _vm._s(
                                              Math.round(
                                                _vm.totalData.statBySite[
                                                  projectId
                                                ].total
                                              ).toLocaleString("ru-RU")
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.totalData.statBySite[
                                                projectId
                                              ].total_percent
                                            ) +
                                            "%)\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c(
                          "td",
                          { key: divId },
                          [
                            _vm.records[divId]
                              ? [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.records[divId].total_cost
                                            ? _vm.records[
                                                divId
                                              ].total_cost.toLocaleString(
                                                "ru-RU"
                                              )
                                            : 0
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "site_sum" },
                                      _vm._l(
                                        _vm.records[divId].sites,
                                        function (data, siteId) {
                                          return _c("p", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$AllProjects[siteId]
                                                    ?.title ??
                                                    "no title " + siteId
                                                ) +
                                                ":\n                      "
                                            ),
                                            data
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      Math.round(
                                                        data.cost
                                                      ).toLocaleString("ru-RU")
                                                    ) +
                                                      "\n                          (" +
                                                      _vm._s(
                                                        Math.round(
                                                          (data.cost * 100) /
                                                            _vm.records[divId]
                                                              .total_cost
                                                        )
                                                      ) +
                                                      "%)"
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("0")]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              : [
                                  _vm._v(
                                    "\n                no data\n              "
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalData.cost.toLocaleString("ru-RU"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "site_sum" },
                          [
                            _vm._l(
                              _vm.$AllProjects,
                              function (project, projectId) {
                                return [
                                  _vm.totalData.statBySite[projectId]
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              project?.title ??
                                                "no title " + projectId
                                            ) +
                                            ": " +
                                            _vm._s(
                                              Math.round(
                                                _vm.totalData.statBySite[
                                                  projectId
                                                ].cost
                                              ).toLocaleString("ru-RU")
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.totalData.statBySite[
                                                projectId
                                              ].cost_percent
                                            ) +
                                            "%)\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c("td", { key: divId }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                (_vm.writeOff[divId] &&
                                  _vm.writeOff[divId].toLocaleString(
                                    "ru-RU"
                                  )) ||
                                  0
                              )
                            ),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.writeOff.total.toLocaleString("ru-RU"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c(
                          "td",
                          { key: divId },
                          [
                            _vm.expenses[divId]
                              ? [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.expenses[
                                            divId
                                          ].div.toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              : [_vm._v("\n                0\n              ")],
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.expenses.totalDiv.toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c("td", { key: divId }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                (
                                  (_vm.expenses[divId] &&
                                    _vm.expenses[divId].globalPartly) ||
                                  0
                                ).toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.expenses.totalGlobalPartly.toLocaleString(
                                "ru-RU"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c("td", { key: divId }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                (
                                  ((_vm.expenses[divId] &&
                                    _vm.expenses[divId].div) ||
                                    0) +
                                  ((_vm.expenses[divId] &&
                                    _vm.expenses[divId].globalPartly) ||
                                    0)
                                ).toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              (
                                _vm.expenses.totalDiv +
                                _vm.expenses.totalGlobalPartly
                              ).toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._l(_vm.divisionToDisplay, function (divId) {
                        return _c("td", { key: divId }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                (
                                  (_vm.expenses[divId] &&
                                    _vm.expenses[divId].profit) ||
                                  0
                                ).toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                        ])
                      }),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.expenses.grandProfit.toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [
        _vm._v("Общая выручка (за минусом зарплаты)"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [_vm._v("Себестоимость")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [_vm._v("Списание препаратов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [_vm._v("Расходы старшего курьера")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [
        _vm._v("Пропорциональная часть общих расходов"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [_vm._v("Всего расходов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "p-0" }, [
      _c("div", { staticClass: "p-1" }, [_vm._v("ИТОГО прибыль")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }